export const contactsData = {
    email: 'ankush.soc@gmail.com',
    phone: '+91 7978924503',
    address: 'Bhubaneswar, Odisha, India - 751012 ',

    sheetAPI: ''
}